import { render, staticRenderFns } from "./SimModalEdicion.vue?vue&type=template&id=dd806fb6&scoped=true&"
import script from "./SimModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./SimModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./SimModalEdicion.vue?vue&type=style&index=0&id=dd806fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd806fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dd806fb6', component.options)
    } else {
      api.reload('dd806fb6', component.options)
    }
    module.hot.accept("./SimModalEdicion.vue?vue&type=template&id=dd806fb6&scoped=true&", function () {
      api.rerender('dd806fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/SimModalEdicion.vue"
export default component.exports